import styled from "styled-components";

import { colors } from "@ntemarked/mittne-components";

export const EmptyText = styled.p`
	margin: 0;
	font-size: 0.875rem;
	color: ${colors.grey700};
`;

export const SectionTitle = styled.div`
	font-weight: 700;
	font-size: 0.875rem;
	color: ${colors.grey800};
	margin-bottom: 0.625rem;
`;

export const ButtonRow = styled.div`
	display: flex;
	gap: 0.5rem;
	margin-top: 0.75rem;
`;

export const ModalBody = styled.div`
	padding: 1.5rem;
	max-width: 28rem;
`;

export const ErrorText = styled.p`
	margin: 0.625rem 0 0;
	font-size: 0.875rem;
	color: ${colors.coral};
`;

export const Section = styled.div`
	margin-top: 1.5rem;
	padding-top: 1.125rem;
	box-shadow: inset 0 1px 0 ${colors.grey300};
`;
